import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrExpansionPanelComponent } from './pr-expansion-panel.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrTooltipIconModule } from '../pr-tooltip-icon/pr-tooltip-icon.module';
import { PrSeparatorModule } from '../pr-separator/pr-separator.module';

@NgModule({
  declarations: [PrExpansionPanelComponent],
  imports: [
    CommonModule,
    MatExpansionModule,
    PrIconModule,
    PrTooltipIconModule,
    PrSeparatorModule,
  ],
  exports: [PrExpansionPanelComponent],
})
export class PrExpansionPanelModule {}
